/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import Storage from "../../../services/local-store";
import {
  Modal,
  Select,
  Popover,
  Button,
  Input,
  Tooltip,
  Checkbox,
} from "antd";
import { CheckCircleFilled } from '@ant-design/icons';
import { LoadingOutlined } from '@ant-design/icons';

class AppointementCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      popupclicked: false,
    };
  }

  // assignRoom(value) {
  //     // console.log("changed values----");
  //     // console.log(this.props.item);
  //     // console.log(`selected value`,value);

  //     let currentObj = this.props.item;
  //     let QueueList = Storage.getJson('QueueList');
  //     let billingPatients = Storage.getJson('billingPatients');
  //     QueueList.forEach((item1)=> {
  //         if(item1.roomNumber === value){
  //             currentObj.status = 'patient-arrived';
  //             item1.patients = [...item1.patients,currentObj];
  //         }
  //     });
  //     billingPatients.forEach((d,i)=>{
  //         if(d.UMR === currentObj.UMR){
  //             billingPatients.splice(i,1)
  //         }
  //     })
  //     this.props.refreshData(QueueList,billingPatients);
  // }
  hide = () => {
    this.setState({
      popupclicked: false,
    });
  };
  // prepareRoomsData(){
  //     let QueueList = Storage.getJson('QueueList');
  //     let roomNumbers = [];
  //      QueueList.map((data,index)=>{
  //          if(data.roomNumber !== undefined && data.roomNumber !== null){
  //             roomNumbers.push({"roomNumber":data.roomNumber})
  //          }
  //      })
  //      return roomNumbers;
  // }

  handleClickChange = (visible) => {
    this.setState({
      popupclicked: visible,
    });
  };
  onCheckBoxSelect() {
    console.log("checked value-------");
    console.log(this);
  }

  render() {
    const item = this.props.item;
    //     const Option = Select.Option;
    //    // const rooms = this.prepareRoomsData();

    const patient_details = (
      <div>
        <p className="mb-0">
          Service Group :{" "}
          {item.service_group_name ? item.service_group_name : "--"}
        </p>
        <p className="mb-0">
          Service : {item.service_name ? item.service_name : "--"}
        </p>
        <p className="mb-0">
          App. Token :{" "}
          <b>{item.appointment_token ? item.appointment_token : "--"}</b>
        </p>
      </div>
    );

    return (
      <div class="px-3 py-1 b-card-body">
        <div className="row">
          <div class="col-6">
            <div className="row">
              <p className="text-p-light col-12">
                {item.is_patient_arrival == "YES" ? (
                  <Popover
                    overlayClassName="popover-custom"
                    content={
                      <p className="mb-0">Patient arrival confirmed on IVR</p>
                    }
                    title=""
                  >
                    {/* <Icon
                      type="check-circle"
                      theme="filled"
                      style={{
                        verticalAlign: "middle",
                        transform: "rotate(0deg)",
                        fontSize: "15px",
                        marginRight: "2px",
                      }}
                    /> */}
                    <CheckCircleFilled
  style={{
    verticalAlign: "middle",
    transform: "rotate(0deg)",
    fontSize: "15px",
    marginRight: "2px",
  }}
/>

                  </Popover>
                ) : (
                  <Popover
                    overlayClassName="popover-custom"
                    content={
                      <p className="mb-0">Waiting for IVR confirmation</p>
                    }
                    title=""
                  >
                    {/* <Icon
                      type="hourglass"
                      theme="filled"
                      style={{
                        verticalAlign: "middle",
                        transform: "rotate(0deg)",
                        fontSize: "15px",
                        marginRight: "2px",
                      }}
                    /> */}
                    <LoadingOutlined
  style={{
    verticalAlign: "middle",
    transform: "rotate(0deg)",
    fontSize: "15px",
    marginRight: "2px",
  }}
/>
                  </Popover>
                )}{" "}
                {item.name}
              </p>
              <p className="text-p-bold col-12 mt-1">
                <Popover
                  overlayClassName="popover-custom"
                  content={patient_details}
                  title=""
                >
                  <img
                    src="/assets/images/icons/info_icon.png"
                    alt="info-image-alt"
                  />
                </Popover>
                {item.phonenumber ? item.phonenumber : "--"}
              </p>
            </div>
          </div>
          <div className="col-6 pl-0 text-right small">
            {`${item.start_time} - ${item.end_time}`}
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-7 my-auto">
            <div className="row">
              <div className="col-6">
                <p className="text-p-light f-12 text-uppercase">
                  <img
                    src="/assets/images/icons/card-user-icon.png"
                    alt="qms-image-alt"
                  />{" "}
                  {item.patienttype}
                </p>
              </div>
              <div className="col-6">
                <p className="text-p-light f-12">
                  <img
                    src="/assets/images/icons/card-wallet.png"
                    alt="qms-image-alt"
                  />{" "}
                  {item.payment_status ? item.payment_status : "NA"}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="row">
                    <div class="col-12 my-auto">
                        <div className="row">
                            <div className="col-4">
                                <p className="text-p-bold">

                                    <Checkbox onChange={this.onCheckBoxSelect.bind(this)}>Coming</Checkbox>
                                    </p>
                            </div>
                            <div className="col-4">
                                <p className="text-p-bold">

                                    <Checkbox onChange={this.onCheckBoxSelect.bind(this)}>Re-schedule</Checkbox>
                                    </p>
                            </div>
                            <div className="col-4">
                                <p className="text-p-bold">

                                    <Checkbox onChange={this.onCheckBoxSelect.bind(this)}>Cancel</Checkbox>
                                    </p>
                            </div>
                        </div>

                    </div>
                </div>
             */}
      </div>
    );
  }
}

export default AppointementCard;
